// Test
//export const baseUrl="http://127.0.0.1:8888/";

// Prod
export const baseUrl="http://lagerliste.webdata.ch/server/";
//export const baseUrl="http://xfact.ch/server0323/";
